import { toast } from 'react-toastify'

export const errorToastMessage = (message: string) => toast.error(message)
